<template>
  <div data-cy="endereco-container">
    <b-row data-cy="endereco-row-cep-cidade-uf">
      <b-col lg="3" md="4" sm="12" class="mt-1" data-cy="endereco-col-cep">
        <label for="cep" v-required data-cy="endereco-label-cep">
          CEP
        </label>
        <b-form-input
          id="cep"
          class="form-control"
          type="text"
          :state="validation.cep"
          v-model="form.cep"
          @keyup="cepChange($event)"
          placeholder="CEP"
          v-mask="[`#####-###`]"
          required
          data-cy="endereco-input-cep"
        />
      </b-col>

      <b-col md="6" sm="12" class="mt-1" data-cy="endereco-col-cidade">
        <label for="cidade" v-required data-cy="endereco-label-cidade">
          Cidade
        </label>
        <b-form-input
          class="form-control"
          type="text"
          ref="cidade"
          :state="validation.cidade"
          v-model="form.cidade"
          id="cidade"
          placeholder="Cidade"
          required
          data-cy="endereco-input-cidade"
        />
      </b-col>

      <b-col lg="3" md="2" sm="12" class="mt-1" data-cy="endereco-col-uf">
        <label for="uf" v-required data-cy="endereco-label-uf">
          UF
        </label>
        <b-form-select
          id="uf"
          v-model="form.uf"
          :state="validation.uf"
          required
          placeholder="Selecione"
          data-cy="endereco-select-uf"
        >
          <option
            :value="null"
            disabled
            hidden
            data-cy="endereco-option-uf-null"
          >
            -- Selecione --
          </option>
          <option
            v-for="uf in ufs"
            :value="uf"
            :key="uf"
            :data-cy="`endereco-option-uf-${uf}`"
          >
            {{ uf }}
          </option>
        </b-form-select>
      </b-col>
    </b-row>

    <b-row data-cy="endereco-row-rua-numero-bairro">
      <b-col md="6" sm="12" class="mt-1" data-cy="endereco-col-rua">
        <label for="rua" v-required data-cy="endereco-label-rua">
          Rua
        </label>
        <b-form-input
          class="form-control"
          type="text"
          ref="rua"
          v-model="form.rua"
          :state="validation.rua"
          id="rua"
          placeholder="Rua"
          required
          data-cy="endereco-input-rua"
        />
      </b-col>

      <b-col md="2" sm="12" class="mt-1" data-cy="endereco-col-numero">
        <label for="numero" v-required data-cy="endereco-label-numero">
          Nº
        </label>
        <b-form-input
          class="form-control"
          type="text"
          ref="numero"
          v-model="form.numero"
          :state="validation.numero"
          id="numero"
          placeholder="Nº"
          required
          data-cy="endereco-input-numero"
        />
      </b-col>

      <b-col md="4" sm="12" class="mt-1" data-cy="endereco-col-bairro">
        <label for="bairro" v-required data-cy="endereco-label-bairro">
          Bairro
        </label>
        <b-form-input
          class="form-control"
          type="text"
          ref="bairro"
          v-model="form.bairro"
          :state="validation.bairro"
          id="bairro"
          placeholder="Bairro"
          required
          data-cy="endereco-input-bairro"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ufs } from "@/core/enumHelper";
import { mask } from "vue-the-mask";
import { axiosInstance as Axios } from "@/main";

export default {
  name: "endereco",
  props: ["form", "validation"],
  directives: { mask },
  data() {
    return {
      ufs: ufs
    };
  },
  methods: {
    async cepChange() {
      const cep = (this.form.cep || "").replace(/\D/g, "");

      if (cep.length === 8) {
        const cepInfo = await Axios.get(`https://viacep.com.br/ws/${cep}/json`);

        this.form.bairro = cepInfo.data.bairro;
        this.form.rua = cepInfo.data.logradouro;
        this.form.uf = cepInfo.data.uf;
        this.form.cidade = cepInfo.data.localidade;
      }
    }
  }
};
</script>

<style scoped></style>
